enum DocumentType {
  FlowModelSchemaSteps = 1,
  FlowModelSchemaMap = 2,
  FlowModelSchemaMapAndSteps = 3,
  Flow = 4
}

export default DocumentType;
